<template>
  <svg
    role="img"
    aria-label="download icon"
    class="download-small-icon o-icon"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    fill="none"
  >
    <title>Download Small</title>

    <g>
      <path
        d="M13.5998 15.9101H2.3998C1.0998 15.9101 0.0498047 14.8601 0.0498047 13.5601V10.3601C0.0498047 9.95011 0.389805 9.61011 0.799805 9.61011C1.2098 9.61011 1.5498 9.95011 1.5498 10.3601V13.5601C1.5498 14.0301 1.9298 14.4101 2.3998 14.4101H13.5998C14.0698 14.4101 14.4498 14.0301 14.4498 13.5601V10.3601C14.4498 9.95011 14.7898 9.61011 15.1998 9.61011C15.6098 9.61011 15.9498 9.95011 15.9498 10.3601V13.5601C15.9498 14.8601 14.8998 15.9101 13.5998 15.9101Z"
        fill="currentColor"
      />
      <path
        d="M12.5299 5.83001C12.2399 5.54001 11.7599 5.54001 11.4699 5.83001L8.74994 8.55001V0.76001C8.74994 0.35001 8.40994 0.0100098 7.99994 0.0100098C7.58994 0.0100098 7.24994 0.35001 7.24994 0.76001V8.55001L4.52994 5.83001C4.23994 5.54001 3.75994 5.54001 3.46994 5.83001C3.17994 6.12001 3.17994 6.60001 3.46994 6.89001L7.46994 10.89C7.53994 10.96 7.61994 11.01 7.70994 11.05C7.79994 11.09 7.89994 11.11 7.99994 11.11C8.09994 11.11 8.19994 11.09 8.28994 11.05C8.37994 11.01 8.45994 10.96 8.52994 10.89L12.5299 6.89001C12.8199 6.60001 12.8199 6.12001 12.5299 5.83001Z"
        fill="currentColor"
      />
    </g>
  </svg>
</template>

<style lang="scss" scoped>
.download-small-icon {
  height: 16px;
  width: 16px;
}
</style>
